import Nullstack from 'nullstack';
export default function IconAdjustmentsAlt({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-adjustments-alt",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "8",
    width: "4",
    height: "4"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "4",
    x2: "6",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "12",
    x2: "6",
    y2: "20"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "14",
    width: "4",
    height: "4"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "4",
    x2: "12",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "20"
  }), "   ", Nullstack.element("rect", {
    x: "16",
    y: "5",
    width: "4",
    height: "4"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "4",
    x2: "18",
    y2: "5"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "9",
    x2: "18",
    y2: "20"
  }), " ");
}